/**
 * O 409 de `POST /clients/:id/rateio` (backend #300): o rateio que se quer gravar
 * tem cota ACORDADA por empresa diferente da CALCULADA. Sem `recalcularCotas`, o
 * backend recusa; com `recalcularCotas: true`, grava e registra no log quem pediu
 * e o que mudou.
 *
 * Ainda não há tela que salve o rateio (a de editar/aplicar entra com a Fase 1 do
 * front). Este módulo e o `AvisoDeCotasDivergentes` ficam prontos para ela.
 */
export interface EmpresaComCotaDivergente {
  clientId: number;
  nome: string;
  acordado: number;
  calculado: number;
  deltaCentavos: number;
  /** Já vem com sinal e em reais. */
  deltaReais: number;
}

export interface CotasDivergentes {
  erro: 'cotas_acordadas_divergem';
  /** Texto pronto do backend: mostrar como está. */
  mensagem: string;
  /** 'YYYY-MM' */
  competenciaInicio: string;
  empresas: EmpresaComCotaDivergente[];
  comoProsseguir?: string;
}

/** Devolve o corpo do 409 quando o erro é o de cotas divergentes; senão, null. */
export function lerCotasDivergentes(err: any): CotasDivergentes | null {
  const r = err?.response;
  if (r?.status !== 409) return null;
  const d = r.data;
  if (!d || d.erro !== 'cotas_acordadas_divergem' || !Array.isArray(d.empresas)) return null;
  return d as CotasDivergentes;
}
